/**
 * Utility function to generate a color based on a key.
 *
 * @param key - The key to generate a color for.
 * @returns A HSL color string.
 */
export function getColorForKey(key: string): string {
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = key.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash % 360); // H: 0 - 360
  const saturation = 70; // S: 70% for vibrancy
  const lightness = 50; // L: 50% for mid-range lightness
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

/**
 * Utility function to get the adjusted opacity based on the active index.
 *
 * @param activeIndex - The active index.
 * @param currentIndex - The current index.
 * @param defaultOpacity - The default opacity.
 * @returns The adjusted opacity.
 */
export const getAdjustedOpacity = <T>(
  activeIndex: number | null,
  currentIndex: number,
  defaultOpacity: T,
) => {
  return activeIndex != null && activeIndex !== currentIndex
    ? 0.1
    : defaultOpacity;
};
